import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';

import CommonTokenExpired from './components/CommonTokenExpired';

/** withRouter */
import withRouter from "./components/withRouter"

/** start individual component */
// import InputMatchingDemandSupply from './inputs/InputMatchingDemandSupply';
import SearchMatchingDemandSupply from './searchs/SearchMatchingDemandSupply';
import DataTableMatchingDemandSupply from './dataTables/DataTableMatchingDemandSupply';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/MatchingDemandSupplyState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `matching_demand_supply_summary`;
const URL = `api/master/${TABLE}`;
const DETAIl_URL = `api/lookup/matching_demand_supply_summary_detail`;

class MatchingDemandSupply extends Component {

    constructor(props){
        super(props);

        this.state = {
        ...GlobalStates,
        ...PageDataState,
        DetailMap: {}    // ✅ บังคับ init
        };
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: 'academy', filter: [{field: "status", value: "0"}]},
            {key: 'target_industries', filter: [{field: "status", value: "0"}]},
            {key: "education_level", filter: [{field: "status", value: "0"}] }, 

            {key: "skills_set_type", filter: [{field: "status", value: "0"}]},
            {key: "skills_set", filter: [{field: "status", value: "0"}]},

            {key: "position", filter: [{field: "status", value: "0"}]},

            
            {key: 'matching_demand_supply_summary_detail', filter: [{field: "status", value: "0"}]},
        ]; 
        await Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable(
            this.updateState,
            `${URL}/view`,
            fn.getInputSearch({
                ...Searchs,
                page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }
            })
        );
        await this.resetApproved(false);
    }

    loadDetailByEstablishment = async (data) => {
        const { manpower_establishments_id, academy_name } = data;
        const { Masterbase } = this.state;

        const result = (Masterbase?.matching_demand_supply_summary_detail || []).filter(item =>
            String(item.manpower_establishments_id) === String(manpower_establishments_id) &&
            String(item.academy_name) === String(academy_name)
        );

        const detailKey = `${manpower_establishments_id}_${academy_name}`;

        this.updateState(prev => ({
            DetailMap: {
                ...prev.DetailMap,
                [detailKey]: result
            }
        }));
    };


    updateSomething = async (obj, element, pk) => {
        await Actions.updateSomething(this.updateState, `${URL}/update-something`, element, pk, obj, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable,
            null,
            false
        );
        await this.resetApproved(false);
    }

    parametersControl = async (state) => {
        if (state) {
            const { direction, key, restore, ...object } = state;
            await Actions.parametersPrompt(this.updateState, key, object[key], restore);
        }
    
        const shouldInitialize = !!state; 
        if (shouldInitialize) {
            await this.initialize();
        }
    };

    resetApproved = async (approved) => {
        this.updateState(
            (prevState) => ({
                ...prevState,
                Approved: approved
            })
        );        
    }

    componentDidMount = async () => {
        const state = this.props.location.state || {} ;
        
        if (util.isObject(state)){
            this.parametersControl(state); 
        } else {
            await this.initialize(); 
        }
    }

    autoLoadDetails = async (rows) => {
        const { DetailMap = {} } = this.state;

        for (const row of rows) {
            const id = row.manpower_establishments_id;
            const academy_name = row.academy_name;
            const detailKey = `${id}_${academy_name}`;
            const data = { manpower_establishments_id: id, academy_name: academy_name };

            // กันโหลดซ้ำ
            if (DetailMap[detailKey]) continue;

            await this.loadDetailByEstablishment(data);
        }
        console.log("DetailMap", this.state.DetailMap);
        
    };

    componentDidUpdate(prevProps, prevState) {
        const prevRows = prevState.DataTable?.rows || [];
        const currRows = this.state.DataTable?.rows || [];

        // rows เปลี่ยนจริง (pagination / search / refresh)
        if (prevRows !== currRows && currRows.length > 0) {
            this.autoLoadDetails(currRows);
        }
    }


    render = () => {

        let { Action, Searchs, DataTable, Inputs, ReadOnlys, InputGroup, Masterbase, Deletes, Operation, Approved, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchMatchingDemandSupply 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableMatchingDemandSupply 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        DetailMap={this.state.DetailMap} 
                        
                        onLoadDetail={this.loadDetailByEstablishment}

                        // onSetEdit={async (e, obj, approved = false) => { await this.fetchForEdit(obj, approved); }}
                        // onNavigate={(e, obj) => this.navigate(e, obj)}
                        onDropDownChange={async(e, element, pk) => { await this.updateSomething(e, element, pk)} }

                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                </Container>
            </>
        )
    }
}

export default withRouter(MatchingDemandSupply);